import { UpdateTicketDraft } from 'types';

const UpdateDraft = {
  checkForUpdateTicketDraft(
    ticketId: string,
    updateTicketDraft: UpdateTicketDraft,
  ) {
    return (
      updateTicketDraft &&
      updateTicketDraft[ticketId] &&
      !!updateTicketDraft[ticketId].message
    );
  },
};

export { UpdateDraft };
